class POCConfig {
}

POCConfig.STRIPE_PUBLISHABLE_KEY = "pk_live_HjmD4zRlYG3QtxN75YQVRMFX00NBvdyrcA"
POCConfig.ALGOLIA_APP_ID = "0O4Z1EQIV8"
POCConfig.ALGOLIA_SEARCH_KEY = "a8f4a73b1a0241dd9bb5f9b4bd530d29"
POCConfig.ALGOLIA_ADMIN_SEARCH_KEY = "449f20e78c7937b221a9b731ebdf3ca2"

export default POCConfig;
